
// 存储键名常量
export const STORAGE_KEYS = {
    ACTIVE_MENU: 'agentActiveMenu',
    USER_PREFERENCES: 'agentUserPreferences'
}

// 路由路径常量
export const ROUTE_PATHS = {
    LOGIN: '/login',
    WORKBENCH: '/agentHome/workbench',
    AGENT_HOME: '/agentHome'
}

// 菜单配置常量
export const MENU_CONFIG = [
    {
        index: '0',
        title: '项目管理',
        icon: 'el-icon-folder-opened',
        route: '/agentHome/agentProject?type=1'
    },
    // 采购计划
    {
        index: '1',
        title: '采购计划',
        icon: 'el-icon-s-marketing',
        route: '/agentHome/biddingPlanIndex'
    },
    {
        index: '2',
        title: '企业采购',
        icon: 'el-icon-shopping-cart-2',
        children: [
            { index: '1-1', title: '公开招标', route: '/agentHome/openTendering?type=1' },
            { index: '1-2', title: '竞争性谈判', route: '/agentHome/competitiveNegotiation?type=1' },
            { index: '1-3', title: '竞争性磋商', route: '/agentHome/competitiveConsultation?type=1' },
            { index: '1-4', title: '邀请招标', route: '/agentHome/invitationTendering?type=1' },
            { index: '1-5', title: '询比价采购', route: '/agentHome/inquiryProcurement?type=1' },
            { index: '1-6', title: '单一来源', route: '/agentHome/singleSource?type=1' }
        ]
    },
    {
        index: '3',
        title: '政府采购',
        icon: 'el-icon-office-building',
        children: [
            { index: '2-1', title: '公开招标', route: '/agentHome/govOpenTendering?type=2' },
            { index: '2-2', title: '竞争性谈判', route: '/agentHome/govCompetitiveNegotiation?type=2' },
            { index: '2-3', title: '竞争性磋商', route: '/agentHome/govCompetitiveConsultation?type=2' },
            { index: '2-4', title: '邀请招标', route: '/agentHome/govInvitationTendering?type=2' },
            { index: '2-5', title: '询比价采购', route: '/agentHome/govInquiryProcurement?type=2' },
            { index: '2-6', title: '单一来源', route: '/agentHome/govSingleSource?type=2' }
        ]
    },
    {
        index: '4',
        title: '建设工程',
        icon: 'el-icon-s-home',
        children: [
            { index: '3-1', title: '公开招标', route: '/agentHome/constructionOpenTendering?type=3' },
            { index: '3-2', title: '邀请招标', route: '/agentHome/govInvitationTendering?type=3' },
            { index: '3-3', title: '招标项目计划', route: '/agentHome/biddingPlan?type=3' },
            // { index: '3-4', title: '勘探通知', route: '/agentHome/pioneerList?type=3' },
        ]
    },
    {
        index: '5',
        title: '半流程',
        icon: 'el-icon-s-operation',
        children: [
            { index: '4-1', title: '发布招标公告', route: '/agentHome/semiProcess' },
            // { index: '4-2', title: '测试河北Ca', route: '/agentHome/testHBCA' }
        ]
    },

    {
        index: '6',
        title: '财务管理',
        icon: 'el-icon-money',
        children: [
            { index: '6-1', title: '核实标书款', route: '/agentHome/financeManagement' },
            { index: '6-2', title: '核实保证金', route: '/agentHome/earnestMoneyCheck' },
            { index: '6-3', title: '核退保证金', route: '/agentHome/earnestMoneyRefund' }


        ]
    },
    {
        index: '7',
        title: '综合管理',
        icon: 'el-icon-s-management',
        children: [
            { index: '7-1', title: '招标公告审核', route: '/agentHome/announcementAudit' },
            { index: '7-2', title: '中标候选人公示审核', route: '/agentHome/candidateAudit' },
            { index: '7-3', title: '中标结果公告审核', route: '/agentHome/resultAudit' },
            { index: '7-4', title: '中标/招标结果通知审核', route: '/agentHome/noticeAudit' },
            { index: '7-5', title: '修改审核状态', route: '/agentHome/auditStatusModify' },
            { index: '7-6', title: '投标人报名审核', route: '/agentHome/bidderRegistrationAudit' }
        ]
    },
    {
        index: '8',
        title: '专家管理',
        icon: 'el-icon-user',
        children: [
            { index: '8-1', title: '专家信息维护', route: '/agentHome/expertInfoMaintenance' },
            { index: '8-2', title: '专家抽取审核', route: '/agentHome/expertExtractionAudit' },
            { index: '8-3', title: '专家抽取列表', route: '/agentHome/expertExtractionList' }
        ]
    },
    {
        index: '9',
        title: '系统管理',
        icon: 'el-icon-setting',
        children: [
            // { index: '9-1', title: '绑定CA', route: '/agentHome/caBinding' },
            { index: '9-2', title: '组织机构修改', route: '/agentHome/agentorganizationModify' }
        ]
    }
]

// 用户命令类型
export const USER_COMMANDS = {
    LOGOUT: 'logout',
    PROFILE: 'profile',
    SETTINGS: 'settings'
}

// 面包屑配置
export const BREADCRUMB_CONFIG = {
    DEFAULT: [{ title: '首页', route: '/agentHome' }],
    '/agentHome/workbench': [
        { title: '首页', route: '/agentHome' },
        { title: '工作台', route: '/agentHome/workbench' }
    ],
    '/agentHome/agentProject?type=1': [
        { title: '首页', route: '/agentHome' },
        { title: '项目管理', route: '/agentHome/agentProject?type=1' }
    ],
    
    '/agentHome/openTendering?type=1': [
        { title: '首页', route: '/agentHome' },
        { title: '企业采购' },
        { title: '公开招标', route: '/agentHome/openTendering?type=1' }
    ],
    '/agentHome/competitiveNegotiation?type=1': [
        { title: '首页', route: '/agentHome' },
        { title: '企业采购' },
        { title: '竞争性谈判', route: '/agentHome/competitiveNegotiation?type=1' }
    ],
    '/agentHome/competitiveConsultation?type=1': [
        { title: '首页', route: '/agentHome' },
        { title: '企业采购' },
        { title: '竞争性磋商', route: '/agentHome/competitiveConsultation?type=1' }
    ],
    '/agentHome/invitationTendering?type=1': [
        { title: '首页', route: '/agentHome' },
        { title: '企业采购' },
        { title: '邀请招标', route: '/agentHome/invitationTendering?type=1' }
    ],
    '/agentHome/inquiryProcurement?type=1': [
        { title: '首页', route: '/agentHome' },
        { title: '企业采购' },
        { title: '询比价采购', route: '/agentHome/inquiryProcurement?type=1' }
    ],
    '/agentHome/singleSource?type=1': [
        { title: '首页', route: '/agentHome' },
        { title: '企业采购' },
        { title: '单一来源', route: '/agentHome/singleSource?type=1' }
    ],
    '/agentHome/govOpenTendering?type=2': [
        { title: '首页', route: '/agentHome' },
        { title: '政府采购' },
        { title: '公开招标', route: '/agentHome/govOpenTendering?type=2' }
    ],
    '/agentHome/govCompetitiveNegotiation?type=2': [
        { title: '首页', route: '/agentHome' },
        { title: '政府采购' },
        { title: '竞争性谈判', route: '/agentHome/govCompetitiveNegotiation?type=2' }
    ],
    '/agentHome/govCompetitiveConsultation?type=2': [
        { title: '首页', route: '/agentHome' },
        { title: '政府采购' },
        { title: '竞争性磋商', route: '/agentHome/govCompetitiveConsultation?type=2' }
    ],
    '/agentHome/govInvitationTendering?type=2': [
        { title: '首页', route: '/agentHome' },
        { title: '政府采购' },
        { title: '邀请招标', route: '/agentHome/govInvitationTendering?type=2' }
    ],
    '/agentHome/govInquiryProcurement?type=2': [
        { title: '首页', route: '/agentHome' },
        { title: '政府采购' },
        { title: '询比价采购', route: '/agentHome/govInquiryProcurement?type=2' }
    ],
    '/agentHome/govSingleSource?type=2': [
        { title: '首页', route: '/agentHome' },
        { title: '政府采购' },
        { title: '单一来源', route: '/agentHome/govSingleSource?type=2' }
    ],
    '/agentHome/constructionOpenTendering?type=3': [
        { title: '首页', route: '/agentHome' },
        { title: '建设工程' },
        { title: '公开招标', route: '/agentHome/constructionOpenTendering?type=3' }
    ],
    '/agentHome/govInvitationTendering?type=3': [
        { title: '首页', route: '/agentHome' },
        { title: '建设工程' },
        { title: '邀请招标', route: '/agentHome/govInvitationTendering?type=3' }
    ],
    '/agentHome/biddingPlan?type=3': [
        { title: '首页', route: '/agentHome' },
        { title: '建设工程' },
        { title: '招标项目计划', route: '/agentHome/biddingPlan?type=3' }
    ],
    '/agentHome/financeManagement': [
        { title: '首页', route: '/agentHome' },
        { title: '财务管理' },
        { title: '核实标书款', route: '/agentHome/financeManagement' }
    ],
    '/agentHome/earnestMoneyCheck': [
        { title: '首页', route: '/agentHome' },
        { title: '财务管理' },
        { title: '核实保证金', route: '/agentHome/earnestMoneyCheck' }
    ],
    '/agentHome/earnestMoneyRefund': [
        { title: '首页', route: '/agentHome' },
        { title: '财务管理' },
        { title: '核退保证金', route: '/agentHome/earnestMoneyRefund' }
    ],
    '/agentHome/announcementAudit': [
        { title: '首页', route: '/agentHome' },
        { title: '综合管理' },
        { title: '招标公告审核', route: '/agentHome/announcementAudit' }
    ],
    '/agentHome/candidateAudit': [
        { title: '首页', route: '/agentHome' },
        { title: '综合管理' },
        { title: '中标候选人公示审核', route: '/agentHome/candidateAudit' }
    ],
    '/agentHome/resultAudit': [
        { title: '首页', route: '/agentHome' },
        { title: '综合管理' },
        { title: '中标结果公告审核', route: '/agentHome/resultAudit' }
    ],
    '/agentHome/noticeAudit': [
        { title: '首页', route: '/agentHome' },
        { title: '综合管理' },
        { title: '中标/招标结果通知审核', route: '/agentHome/noticeAudit' }
    ],
    '/agentHome/auditStatusModify': [
        { title: '首页', route: '/agentHome' },
        { title: '综合管理' },
        { title: '修改审核状态', route: '/agentHome/auditStatusModify' }
    ],
    '/agentHome/bidderRegistrationAudit': [
        { title: '首页', route: '/agentHome' },
        { title: '综合管理' },
        { title: '投标人报名审核', route: '/agentHome/bidderRegistrationAudit' }
    ],
    '/agentHome/expertInfoMaintenance': [
        { title: '首页', route: '/agentHome' },
        { title: '专家管理' },
        { title: '专家信息维护', route: '/agentHome/expertInfoMaintenance' }
    ],
    '/agentHome/expertExtractionAudit': [
        { title: '首页', route: '/agentHome' },
        { title: '专家管理' },
        { title: '专家抽取审核', route: '/agentHome/expertExtractionAudit' }
    ],
    '/agentHome/expertExtractionList': [
        { title: '首页', route: '/agentHome' },
        { title: '专家管理' },
        { title: '专家抽取列表', route: '/agentHome/expertExtractionList' }
    ],
    '/agentHome/agentorganizationModify': [
        { title: '首页', route: '/agentHome' },
        { title: '系统管理' },
        { title: '组织机构修改', route: '/agentHome/agentorganizationModify' }
    ],

    // ==================== 企业采购 - 招标流程页 ====================
    '/agentHome/politicsProjectFlow?procurementType=1&type=公开招标项目信息': [
        { title: '首页', route: '/agentHome' },
        { title: '企业采购' },
        { title: '公开招标', route: '/agentHome/openTendering?type=1' },
        { title: '公开招标流程' }
    ],
    '/agentHome/politicsProjectFlow?procurementType=1&type=竞争性谈判项目信息': [
        { title: '首页', route: '/agentHome' },
        { title: '企业采购' },
        { title: '竞争性谈判', route: '/agentHome/competitiveNegotiation?type=1' },
        { title: '竞争性谈判流程' }
    ],
    '/agentHome/politicsProjectFlow?procurementType=1&type=竞争性磋商项目信息': [
        { title: '首页', route: '/agentHome' },
        { title: '企业采购' },
        { title: '竞争性磋商', route: '/agentHome/competitiveConsultation?type=1' },
        { title: '竞争性磋商流程' }
    ],
    '/agentHome/politicsProjectFlow?procurementType=1&type=邀请招标项目信息': [
        { title: '首页', route: '/agentHome' },
        { title: '企业采购' },
        { title: '邀请招标', route: '/agentHome/invitationTendering?type=1' },
        { title: '邀请招标流程' }
    ],
    '/agentHome/politicsProjectFlow?procurementType=1&type=询比价采购项目信息': [
        { title: '首页', route: '/agentHome' },
        { title: '企业采购' },
        { title: '询比价采购', route: '/agentHome/inquiryProcurement?type=1' },
        { title: '询比价采购流程' }
    ],
    '/agentHome/politicsProjectFlow?procurementType=1&type=单一来源项目信息': [
        { title: '首页', route: '/agentHome' },
        { title: '企业采购' },
        { title: '单一来源', route: '/agentHome/singleSource?type=1' },
        { title: '单一来源流程' }
    ],

    // ==================== 政府采购 - 招标流程页 ====================
    '/agentHome/govPoliticsProjectFlow?procurementType=2&type=公开招标项目信息': [
        { title: '首页', route: '/agentHome' },
        { title: '政府采购' },
        { title: '公开招标', route: '/agentHome/govOpenTendering?type=2' },
        { title: '公开招标流程' }
    ],
    '/agentHome/govPoliticsProjectFlow?procurementType=2&type=竞争性谈判项目信息': [
        { title: '首页', route: '/agentHome' },
        { title: '政府采购' },
        { title: '竞争性谈判', route: '/agentHome/govCompetitiveNegotiation?type=2' },
        { title: '竞争性谈判流程' }
    ],
    '/agentHome/govPoliticsProjectFlow?procurementType=2&type=竞争性磋商项目信息': [
        { title: '首页', route: '/agentHome' },
        { title: '政府采购' },
        { title: '竞争性磋商', route: '/agentHome/govCompetitiveConsultation?type=2' },
        { title: '竞争性磋商流程' }
    ],
    '/agentHome/govPoliticsProjectFlow?procurementType=2&type=邀请招标项目信息': [
        { title: '首页', route: '/agentHome' },
        { title: '政府采购' },
        { title: '邀请招标', route: '/agentHome/govInvitationTendering?type=2' },
        { title: '邀请招标流程' }
    ],
    '/agentHome/govPoliticsProjectFlow?procurementType=2&type=询比价采购项目信息': [
        { title: '首页', route: '/agentHome' },
        { title: '政府采购' },
        { title: '询比价采购', route: '/agentHome/govInquiryProcurement?type=2' },
        { title: '询比价采购流程' }
    ],
    '/agentHome/govPoliticsProjectFlow?procurementType=2&type=单一来源项目信息': [
        { title: '首页', route: '/agentHome' },
        { title: '政府采购' },
        { title: '单一来源', route: '/agentHome/govSingleSource?type=2' },
        { title: '单一来源流程' }
    ],

    // ==================== 建设工程 - 招标流程页 ====================
    '/agentHome/constructionPoliticsProjectFlow?procurementType=3&type=公开招标项目信息': [
        { title: '首页', route: '/agentHome' },
        { title: '建设工程' },
        { title: '公开招标', route: '/agentHome/constructionOpenTendering?type=3' },
        { title: '公开招标流程' }
    ],
    '/agentHome/constructionPoliticsProjectFlow?procurementType=3&type=邀请招标项目信息': [
        { title: '首页', route: '/agentHome' },
        { title: '建设工程' },
        { title: '邀请招标', route: '/agentHome/govInvitationTendering?type=3' },
        { title: '邀请招标流程' }
    ]
}

// 流程上下文映射：根据 procurementType_type 确定父级面包屑链
export const FLOW_CONTEXT_MAP = {
    '1_公开招标项目信息':   { module: '企业采购', type: '公开招标',   typeRoute: '/agentHome/openTendering?type=1',              flowTitle: '公开招标流程',   flowPath: '/agentHome/politicsProjectFlow' },
    '1_竞争性谈判项目信息': { module: '企业采购', type: '竞争性谈判', typeRoute: '/agentHome/competitiveNegotiation?type=1',      flowTitle: '竞争性谈判流程', flowPath: '/agentHome/politicsProjectFlow' },
    '1_竞争性磋商项目信息': { module: '企业采购', type: '竞争性磋商', typeRoute: '/agentHome/competitiveConsultation?type=1',     flowTitle: '竞争性磋商流程', flowPath: '/agentHome/politicsProjectFlow' },
    '1_邀请招标项目信息':   { module: '企业采购', type: '邀请招标',   typeRoute: '/agentHome/invitationTendering?type=1',        flowTitle: '邀请招标流程',   flowPath: '/agentHome/politicsProjectFlow' },
    '1_询比价采购项目信息':   { module: '企业采购', type: '询比价采购',   typeRoute: '/agentHome/inquiryProcurement?type=1',         flowTitle: '询比价采购流程',   flowPath: '/agentHome/politicsProjectFlow' },
    '1_单一来源项目信息':   { module: '企业采购', type: '单一来源',   typeRoute: '/agentHome/singleSource?type=1',               flowTitle: '单一来源流程',   flowPath: '/agentHome/politicsProjectFlow' },
    '2_公开招标项目信息':   { module: '政府采购', type: '公开招标',   typeRoute: '/agentHome/govOpenTendering?type=2',            flowTitle: '公开招标流程',   flowPath: '/agentHome/govPoliticsProjectFlow' },
    '2_竞争性谈判项目信息': { module: '政府采购', type: '竞争性谈判', typeRoute: '/agentHome/govCompetitiveNegotiation?type=2',   flowTitle: '竞争性谈判流程', flowPath: '/agentHome/govPoliticsProjectFlow' },
    '2_竞争性磋商项目信息': { module: '政府采购', type: '竞争性磋商', typeRoute: '/agentHome/govCompetitiveConsultation?type=2',  flowTitle: '竞争性磋商流程', flowPath: '/agentHome/govPoliticsProjectFlow' },
    '2_邀请招标项目信息':   { module: '政府采购', type: '邀请招标',   typeRoute: '/agentHome/govInvitationTendering?type=2',      flowTitle: '邀请招标流程',   flowPath: '/agentHome/govPoliticsProjectFlow' },
    '2_询比价采购项目信息':   { module: '政府采购', type: '询比价采购',   typeRoute: '/agentHome/govInquiryProcurement?type=2',       flowTitle: '询比价采购流程',   flowPath: '/agentHome/govPoliticsProjectFlow' },
    '2_单一来源项目信息':   { module: '政府采购', type: '单一来源',   typeRoute: '/agentHome/govSingleSource?type=2',             flowTitle: '单一来源流程',   flowPath: '/agentHome/govPoliticsProjectFlow' },
    '3_公开招标项目信息':   { module: '建设工程', type: '公开招标',   typeRoute: '/agentHome/constructionOpenTendering?type=3',   flowTitle: '公开招标流程',   flowPath: '/agentHome/constructionPoliticsProjectFlow' },
    '3_邀请招标项目信息':   { module: '建设工程', type: '邀请招标',   typeRoute: '/agentHome/govInvitationTendering?type=3',      flowTitle: '邀请招标流程',   flowPath: '/agentHome/constructionPoliticsProjectFlow' }
}

// 子页面标题映射：path → 显示名称（企业/政府共用页面在下面都列出）
export const SUB_PAGE_TITLE_MAP = {
    '/agentHome/politicsProjectCreate':    '标段列表',
    '/agentHome/govPoliticsProjectCreate': '标段列表',
    '/agentHome/tenderProMgmt':            '招标文件管理',
    '/agentHome/govTenderProMgmt':         '招标文件管理',
    '/agentHome/politicsProjectManage':    '标书文件',
    '/agentHome/govPoliticsProjectManage': '标书文件',
    '/agentHome/qualificationReview':      '资格审查设置',
    '/agentHome/govQualificationReview':   '资格审查设置',
    '/agentHome/judgeInfoEntry':           '录入评委信息',
    '/agentHome/govJudgeInfoEntry':        '录入评委信息',
    '/agentHome/bidEvaluationMethodList':  '编制评标办法',
    '/agentHome/bidOpeningHall':           '开标大厅',
    '/agentHome/govBidOpeningHall':        '开标大厅',
    '/agentHome/valuationbefore':          '评标前准备',
    '/agentHome/winningBidAnnouncement':   '中标公告',
    '/agentHome/govWinningBidAnnouncement':'中标公告',
    '/agentHome/winningBidCandidates':     '中标候选人公示',
    '/agentHome/bidResultNotification':    '中标结果通知书',
    '/agentHome/qualificationReviewList':  '资格审查',
    '/agentHome/printReviewResults':       '打印评审结果',
    '/agentHome/evaluationReport':         '评标报告',
    '/agentHome/addEvaluationReport':      '添加评标报告',
    '/agentHome/tenderDocumentClarification': '招标文件澄清与修改',
    '/agentHome/publishTenderAnnouncement':'发布招标公告',
    '/agentHome/addTenderAnnouncement':    '新增招标公告',
    '/agentHome/bidTermination':           '招标异常终止',
    '/agentHome/bidComplaint':             '招标异常投诉',
    '/agentHome/contract':                 '招标合同',
    '/agentHome/contractAdd':              '新增合同',
    '/agentHome/expertExtraction':         '专家抽取',
    '/agentHome/expertExtractionFrom':     '专家抽取',
    '/agentHome/newSingleSource':          '发布邀请书',
    '/agentHome/calculateBidScore':        '计算报价分',
    '/agentHome/expertQuestionView':       '查看专家质疑',
    '/agentHome/oneClickArchive':          '一键归档',
    '/agentHome/answerBidderQuestions':    '解答投标人问题',
    '/agentHome/exportBidAnalysis':        '导出串标分析',
    '/agentHome/bidOpeningSummary':        '开标一览表',
    '/agentHome/stepRealTimeReview':       '实时查看评审结果',
    '/agentHome/creatBidFile':             '创建招标文件',
    '/agentHome/govCreatBidFile':          '创建招标文件',
    '/agentHome/uploadBidFile':            '上传招标文件',
    '/agentHome/govUploadBidFile':         '上传招标文件',
    '/agentHome/detailUploadFile':         '招标文件详情',
    '/agentHome/govDetailUploadFile':      '招标文件详情',
    '/agentHome/pioneerList':              '勘探通知',
    '/agentHome/addBidNotice':             '新增中标公告',
    '/agentHome/govAddBidNotice':          '新增中标公告'
}

// 模块类型映射
export const MODULE_TYPE_MAP = {
    company: '企业采购',
    government: '政府采购',
    construction: '建设工程',
    semi: '半流程'
}

// 页面类型映射
export const PAGE_TYPE_MAP = {
    openTendering: '公开招标',
    competitiveNegotiation: '竞争性谈判',
    competitiveConsultation: '竞争性磋商',
    invitationTendering: '邀请招标',
    inquiryProcurement: '询比价采购',
    singleSource: '单一来源'
}
